var _path, _path2, _rect, _path3, _rect2, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundersDoubleDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#D1B277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2125)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#C7A572"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2125)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102.5L56 73.25H63.9459L77 90.5V102.5Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44L56 73.25H63.9459L77 56V44Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102.5L98 73.25H90.0541L77 90.5V102.5Z",
    fill: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44L98 73.25H90.0541L77 56V44Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.957 73.249L77.0111 55.999L90.0651 73.249L77.0111 90.499L63.957 73.249Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43 128.5L22 99.25H29.9459L43 116.5V128.5Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70L22 99.25H29.9459L43 82V70Z",
    fill: "#F8F8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43 128.5L64 99.25H56.0541L43 116.5V128.5Z",
    fill: "#9F9F9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70L64 99.25H56.0541L43 82V70Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.957 99.249L43.0111 81.999L56.0651 99.249L43.0111 116.499L29.957 99.249Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5437 49.899C41.9191 48.3784 44.0809 48.3784 44.4563 49.899L45.2577 53.1455C45.3912 53.6864 45.8136 54.1087 46.3545 54.2423L49.6009 55.0437C51.1216 55.4191 51.1216 57.5809 49.6009 57.9563L46.3545 58.7577C45.8136 58.8912 45.3912 59.3136 45.2577 59.8545L44.4563 63.1009C44.0809 64.6216 41.9191 64.6216 41.5437 63.1009L40.7423 59.8545C40.6087 59.3136 40.1864 58.8912 39.6455 58.7577L36.399 57.9563C34.8784 57.5809 34.8784 55.4191 36.399 55.0437L39.6455 54.2423C40.1864 54.1087 40.6087 53.6864 40.7423 53.1455L41.5437 49.899Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5437 109.399C75.9191 107.878 78.0809 107.878 78.4563 109.399L79.2577 112.645C79.3912 113.186 79.8136 113.609 80.3545 113.742L83.6009 114.544C85.1216 114.919 85.1216 117.081 83.6009 117.456L80.3545 118.258C79.8136 118.391 79.3912 118.814 79.2577 119.354L78.4563 122.601C78.0809 124.122 75.9191 124.122 75.5437 122.601L74.7423 119.354C74.6087 118.814 74.1864 118.391 73.6455 118.258L70.399 117.456C68.8784 117.081 68.8784 114.919 70.399 114.544L73.6455 113.742C74.1864 113.609 74.6087 113.186 74.7423 112.645L75.5437 109.399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2125",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#CFB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED4A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2125",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersDoubleDiamond);
export default __webpack_public_path__ + "static/media/foundersDoubleDiamond.faa7c5c6bd30759b2470a05055ed840a.svg";
export { ForwardRef as ReactComponent };